import { Advisories } from "../components/Advisories";
import { FormProvider, useForm } from "react-hook-form";
import { SavePrompt } from "@/components";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { ScopeOfWorkSchema } from "../ScopeOfWorkSchema";
import { SOWForm } from "./SOWForm";
import { SOWFormBreadcrumbs } from "./SOWFormBreadcrumbs";
import { SOWFormToolbar } from "./SOWFormToolbar";
import { SOWFormWelders } from "./SOWFormWelders";
import { zodResolver } from "@hookform/resolvers/zod";

export function ScopeOfWorkForm({ data: initialData }: { data: Readonly<ScopeOfWork> }) {
  const form = useForm<ScopeOfWork>({
    defaultValues: initialData,
    resolver: zodResolver(ScopeOfWorkSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
  });

  const data = form.watch();
  const isDirty = Object.keys(form.formState.dirtyFields).length > 0;

  return (
    <SavePrompt when={isDirty}>
      <div style={{ maxWidth: 1000 }}>
        <SOWFormBreadcrumbs data={data} />

        <FormProvider {...form}>
          <div className="d-md-flex justify-content-between mb-2">
            <h3>Scope of Work</h3>
            <SOWFormToolbar data={data} />
          </div>

          <SOWForm data={data} />

          {!data.template && <Advisories data={data} />}
          {!data.template && <SOWFormWelders data={data} />}
        </FormProvider>
      </div>
    </SavePrompt>
  );
}
